class HeaderMenu extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.index = this.container.getAttribute('data-index');
    this.content = document.querySelector(`.mega-menu__content[data-index="${this.index}"]`);

    if (!this.content) return;

    this.header = document.querySelector('.header-wrapper');

    this.container.addEventListener('mouseover', this.open.bind(this));
    this.content.addEventListener('mouseleave', this.close.bind(this));
  }

  open() {
    this.height = this.content.querySelector('.mega-menu__content-bg').getBoundingClientRect().height;
    this.content.style.maxHeight = this.height + 'px';

    if (!this.header) return;
    this.header.classList.add('remove-transparent');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    this.content.style.maxHeight = '0px';

    // if (!this.header) return;
    // this.header.classList.remove('remove-transparent');
  }
}

customElements.define('header-menu', HeaderMenu);

const megaContent = document.querySelector('header-menu');
class MegamenuIcon extends HTMLElement {
  constructor() {
    super();

    this.container = this;

    this.container.addEventListener('click', this.toggleMobileMenu.bind(this));
  }

  toggleMobileMenu() {
    if (!megaContent) return;

    this.container.classList.toggle('is-open');
    if (this.container.classList.contains('is-open')) {
      document.body.classList.add('megamenu-opening');
      megaContent.open();
    } else {
      document.body.classList.remove('megamenu-opening');
      megaContent.close();
    }
  }
}

customElements.define('megamenu-icon', MegamenuIcon);

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll('.js-mega-menu-focus-out').length > 0 && document.querySelectorAll('.mega-menu__content').length > 0)
    document.querySelectorAll('.js-mega-menu-focus-out').forEach((headerDropdownFocusOut) => {
      headerDropdownFocusOut.addEventListener('mouseover', () => {
        closeMegaMenu();
      });
    });
});

function closeMegaMenu() {
  // if (document.querySelectorAll('.header-wrapper').length > 0) {
  //   document.querySelector('.header-wrapper').classList.remove('remove-transparent');
  // }
  document.querySelectorAll('.mega-menu__content').forEach((megaMenuContainer) => {
    megaMenuContainer.style.maxHeight = "0px";
  });
}